














































































































































































































































































































































































































































































































































































































import Agency from "@/store/entities/agency";
import { Component, Vue } from "vue-property-decorator";

import util from "../lib/util";
@Component({})



export default class TopBarMenu extends Vue {
  fullName: string = "";
  agencyName: string = "";
  

  data() {
    return {
      menu: false,
    };
  }

  async created() {

               await this.$store.dispatch({
         type:'agency/getAgencyInfo',
        
         
     })

     

      if(this.$store.state.session.user!=null)
        this.fullName=this.$store.state.session.user.id;
        
        this.agencyName=this.$store.state.agency.select.name;

  }

  logout() {
    this.$store.commit("app/logout", this);
    util.abp.auth.clearToken();
    location.reload();
  }
}
